import { render, staticRenderFns } from "./Festival.vue?vue&type=template&id=628a9271&"
import script from "./Festival.vue?vue&type=script&lang=js&"
export * from "./Festival.vue?vue&type=script&lang=js&"
import style0 from "./Festival.vue?vue&type=style&index=0&id=628a9271&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports